angular.module("ainapp")
    .controller("VoucherSettingsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Voucher Settings";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            MainService.CostCenterList().then(function (response) {
                $scope.CostCenters = response.data;
            }, function (err) {});

            MainService.UnitsInDropdown().then(function (response) {
                $scope.Units = response.data;
            }, function (err) {});


            $scope.Init = function () {

                $scope.load = false;

                $scope.ViewVal = 1;
                $scope.ViewVal2 = 0;
                $scope.ViewValType = 'Material Request';
                $scope.selectedVoucher = 'Material Request';

                $scope.CostSetting = {
                    VoucherName: "Material Request",
                    DebitAccountId: "",
                    CreditAccountId: "",
                    InputVatAccountId: "",
                    OutputVatAccountId: "",
                    InventoryAccountId: "",
                    ExpenseAccountId: "",
                }

                $scope.CompanyProfile2 = {};
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.VoucherAccountsInVoucher("Material Request").then(function (response) {
                    if (response.data != null && response.data != "") {
                        $scope.CompanyProfile2 = response.data;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }
            $scope.Init();


            $scope.switchTab = function (tab, type, voucher) {
                $scope.selectedVoucher = voucher;
                $scope.ViewVal = tab;
                $scope.ViewValType = type;
                $scope.CompanyProfile2 = {};
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.VoucherAccountsInVoucher(type).then(function (response) {
                    if (response.data != null && response.data != "") {
                        $scope.CompanyProfile2 = response.data;
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }



            $scope.saveCostSettings = function () {

                $scope.CompanyProfile2.VoucherName = $scope.ViewValType;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.AddVoucherAccounts($scope.CompanyProfile2).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                        $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }



            $scope.AccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.accountInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.CreditAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.CreditAccount = {};
                    $scope.CompanyProfile2.CreditAccount.Name = data.Name;
                    $scope.CompanyProfile2.CreditAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.CreditAccount.Name == "") {
                        $scope.CompanyProfile2.CreditAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.DebitAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.DebitAccount = {};
                    $scope.CompanyProfile2.DebitAccount.Name = data.Name;
                    $scope.CompanyProfile2.DebitAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.DebitAccount.Name == "") {
                        $scope.CompanyProfile2.DebitAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.InputVatAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.InputVatAccount = {};
                    $scope.CompanyProfile2.InputVatAccount.Name = data.Name;
                    $scope.CompanyProfile2.InputVatAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.InputVatAccount.Name == "") {
                        $scope.CompanyProfile2.InputVatAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.OutputVatAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.OutputVatAccount = {};
                    $scope.CompanyProfile2.OutputVatAccount.Name = data.Name;
                    $scope.CompanyProfile2.OutputVatAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.OutputVatAccount.Name == "") {
                        $scope.CompanyProfile2.OutputVatAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.InventoryAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.InventoryAccount = {};
                    $scope.CompanyProfile2.InventoryAccount.Name = data.Name;
                    $scope.CompanyProfile2.InventoryAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.InventoryAccount.Name == "") {
                        $scope.CompanyProfile2.InventoryAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.ExpenseAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.ExpenseAccount = {};
                    $scope.CompanyProfile2.ExpenseAccount.Name = data.Name;
                    $scope.CompanyProfile2.ExpenseAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.ExpenseAccount.Name == "") {
                        $scope.CompanyProfile2.ExpenseAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.BankAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.BankAccount = {};
                    $scope.CompanyProfile2.BankAccount.Name = data.Name;
                    $scope.CompanyProfile2.BankAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.BankAccount.Name == "") {
                        $scope.CompanyProfile2.BankAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.ClearingChargesAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.ClearingChargesAcc = {};
                    $scope.CompanyProfile2.ClearingChargesAcc.Name = data.Name;
                    $scope.CompanyProfile2.ClearingChargesAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.ClearingChargesAcc.Name == "") {
                        $scope.CompanyProfile2.ClearingChargesAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.CustomsDutyAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.CustomsDutyAcc = {};
                    $scope.CompanyProfile2.CustomsDutyAcc.Name = data.Name;
                    $scope.CompanyProfile2.CustomsDutyAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.CustomsDutyAcc.Name == "") {
                        $scope.CompanyProfile2.CustomsDutyAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.DeliveryChargesAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.DeliveryChargeAcc = {};
                    $scope.CompanyProfile2.DeliveryChargeAcc.Name = data.Name;
                    $scope.CompanyProfile2.DeliveryChargeAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.DeliveryChargeAcc.Name == "") {
                        $scope.CompanyProfile2.DeliveryChargeAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.FreightChargesAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.FreightChargeAcc = {};
                    $scope.CompanyProfile2.FreightChargeAcc.Name = data.Name;
                    $scope.CompanyProfile2.FreightChargeAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.FreightChargeAcc.Name == "") {
                        $scope.CompanyProfile2.FreightChargeAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.DiscountAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.DiscountAccount = {};
                    $scope.CompanyProfile2.DiscountAccount.Name = data.Name;
                    $scope.CompanyProfile2.DiscountAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.DiscountAccount.Name == "") {
                        $scope.CompanyProfile2.DiscountAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.OtherChargesAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.OtherChargeAcc = {};
                    $scope.CompanyProfile2.OtherChargeAcc.Name = data.Name;
                    $scope.CompanyProfile2.OtherChargeAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.OtherChargeAcc.Name == "") {
                        $scope.CompanyProfile2.OtherChargeAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.DefaultCustomerAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.DefaultCustomer = {};
                    $scope.CompanyProfile2.DefaultCustomer.Name = data.Name;
                    $scope.CompanyProfile2.DefaultCustomerId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.DefaultCustomer.Name == "") {
                        $scope.CompanyProfile2.DefaultCustomerId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.ExtraChargesAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.ExtraChargeAcc = {};
                    $scope.CompanyProfile2.ExtraChargeAcc.Name = data.Name;
                    $scope.CompanyProfile2.ExtraChargeAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.ExtraChargeAcc.Name == "") {
                        $scope.CompanyProfile2.ExtraChargeAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.ExtraChargesReversalAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.ExtraChargeReversalAcc = {};
                    $scope.CompanyProfile2.ExtraChargeReversalAcc.Name = data.Name;
                    $scope.CompanyProfile2.ExtraChargeReversalAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.ExtraChargeReversalAcc.Name == "") {
                        $scope.CompanyProfile2.ExtraChargeReversalAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.PackingChargesAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.PackingChargeAcc = {};
                    $scope.CompanyProfile2.PackingChargeAcc.Name = data.Name;
                    $scope.CompanyProfile2.PackingChargeAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.PackingChargeAcc.Name == "") {
                        $scope.CompanyProfile2.PackingChargeAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.CashAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.CashAccount = {};
                    $scope.CompanyProfile2.CashAccount.Name = data.Name;
                    $scope.CompanyProfile2.CashAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.CashAccount.Name == "") {
                        $scope.CompanyProfile2.CashAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.SalesAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.SalesAccount = {};
                    $scope.CompanyProfile2.SalesAccount.Name = data.Name;
                    $scope.CompanyProfile2.SalesAccountId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.SalesAccount.Name == "") {
                        $scope.CompanyProfile2.SalesAccountId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };



            $scope.Field1AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field1Acc = {};
                    $scope.CompanyProfile2.Field1Acc.Name = data.Name;
                    $scope.CompanyProfile2.Field1AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field1Acc.Name == "") {
                        $scope.CompanyProfile2.Field1AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Field2AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field2Acc = {};
                    $scope.CompanyProfile2.Field2Acc.Name = data.Name;
                    $scope.CompanyProfile2.Field2AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field2Acc.Name == "") {
                        $scope.CompanyProfile2.Field2AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Field3AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field3Acc = {};
                    $scope.CompanyProfile2.Field3Acc.Name = data.Name;
                    $scope.CompanyProfile2.Field3AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field3Acc.Name == "") {
                        $scope.CompanyProfile2.Field3AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Field4AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field4Acc = {};
                    $scope.CompanyProfile2.Field4Acc.Name = data.Name;
                    $scope.CompanyProfile2.Field4AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field4Acc.Name == "") {
                        $scope.CompanyProfile2.Field4AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Field5AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field5Acc = {};
                    $scope.CompanyProfile2.Field5Acc.Name = data.Name;
                    $scope.CompanyProfile2.Field5AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field5Acc.Name == "") {
                        $scope.CompanyProfile2.Field5AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.Field21AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field21Acc = {};
                    $scope.CompanyProfile2.Field21Acc.Name = data.Name;
                    $scope.CompanyProfile2.Field21AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field21Acc.Name == "") {
                        $scope.CompanyProfile2.Field21AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Field21DebitAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field21DebitAcc = {};
                    $scope.CompanyProfile2.Field21DebitAcc.Name = data.Name;
                    $scope.CompanyProfile2.Field21DebitAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field21DebitAcc.Name == "") {
                        $scope.CompanyProfile2.Field21DebitAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Field22AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field22Acc = {};
                    $scope.CompanyProfile2.Field22Acc.Name = data.Name;
                    $scope.CompanyProfile2.Field22AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field22Acc.Name == "") {
                        $scope.CompanyProfile2.Field22AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Field22DebitAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field22DebitAcc = {};
                    $scope.CompanyProfile2.Field22DebitAcc.Name = data.Name;
                    $scope.CompanyProfile2.Field22DebitAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field22DebitAcc.Name == "") {
                        $scope.CompanyProfile2.Field22DebitAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Field23AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field23Acc = {};
                    $scope.CompanyProfile2.Field23Acc.Name = data.Name;
                    $scope.CompanyProfile2.Field23AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field23Acc.Name == "") {
                        $scope.CompanyProfile2.Field23AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

             $scope.Field23DebitAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field23DebitAcc = {};
                    $scope.CompanyProfile2.Field23DebitAcc.Name = data.Name;
                    $scope.CompanyProfile2.Field23DebitAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field23DebitAcc.Name == "") {
                        $scope.CompanyProfile2.Field23DebitAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Field24AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field24Acc = {};
                    $scope.CompanyProfile2.Field24Acc.Name = data.Name;
                    $scope.CompanyProfile2.Field24AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field24Acc.Name == "") {
                        $scope.CompanyProfile2.Field24AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Field24DebitAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field24DebitAcc = {};
                    $scope.CompanyProfile2.Field24DebitAcc.Name = data.Name;
                    $scope.CompanyProfile2.Field24DebitAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field24DebitAcc.Name == "") {
                        $scope.CompanyProfile2.Field24DebitAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Field25AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field25Acc = {};
                    $scope.CompanyProfile2.Field25Acc.Name = data.Name;
                    $scope.CompanyProfile2.Field25AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field25Acc.Name == "") {
                        $scope.CompanyProfile2.Field25AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Field25DebitAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field25DebitAcc = {};
                    $scope.CompanyProfile2.Field25DebitAcc.Name = data.Name;
                    $scope.CompanyProfile2.Field25DebitAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field25DebitAcc.Name == "") {
                        $scope.CompanyProfile2.Field25DebitAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

             $scope.Field26AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field26Acc = {};
                    $scope.CompanyProfile2.Field26Acc.Name = data.Name;
                    $scope.CompanyProfile2.Field26AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field26Acc.Name == "") {
                        $scope.CompanyProfile2.Field26AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Field26DebitAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field26DebitAcc = {};
                    $scope.CompanyProfile2.Field26DebitAcc.Name = data.Name;
                    $scope.CompanyProfile2.Field26DebitAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field26DebitAcc.Name == "") {
                        $scope.CompanyProfile2.Field26DebitAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

             $scope.Field27AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field27Acc = {};
                    $scope.CompanyProfile2.Field27Acc.Name = data.Name;
                    $scope.CompanyProfile2.Field27AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field27Acc.Name == "") {
                        $scope.CompanyProfile2.Field27AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.Field27DebitAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field27DebitAcc = {};
                    $scope.CompanyProfile2.Field27DebitAcc.Name = data.Name;
                    $scope.CompanyProfile2.Field27DebitAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field27DebitAcc.Name == "") {
                        $scope.CompanyProfile2.Field27DebitAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

             $scope.Field28AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field28Acc = {};
                    $scope.CompanyProfile2.Field28Acc.Name = data.Name;
                    $scope.CompanyProfile2.Field28AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field28Acc.Name == "") {
                        $scope.CompanyProfile2.Field28AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

             $scope.Field28DebitAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field28DebitAcc = {};
                    $scope.CompanyProfile2.Field28DebitAcc.Name = data.Name;
                    $scope.CompanyProfile2.Field28DebitAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field28DebitAcc.Name == "") {
                        $scope.CompanyProfile2.Field28DebitAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };


             $scope.Field29AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field29Acc = {};
                    $scope.CompanyProfile2.Field29Acc.Name = data.Name;
                    $scope.CompanyProfile2.Field29AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field29Acc.Name == "") {
                        $scope.CompanyProfile2.Field29AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Field29DebitAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field29DebitAcc = {};
                    $scope.CompanyProfile2.Field29DebitAcc.Name = data.Name;
                    $scope.CompanyProfile2.Field29DebitAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field29DebitAcc.Name == "") {
                        $scope.CompanyProfile2.Field29DebitAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

             $scope.Field30AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field30Acc = {};
                    $scope.CompanyProfile2.Field30Acc.Name = data.Name;
                    $scope.CompanyProfile2.Field30AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field30Acc.Name == "") {
                        $scope.CompanyProfile2.Field30AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

             $scope.Field30DebitAccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Field30DebitAcc = {};
                    $scope.CompanyProfile2.Field30DebitAcc.Name = data.Name;
                    $scope.CompanyProfile2.Field30DebitAccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Field30DebitAcc.Name == "") {
                        $scope.CompanyProfile2.Field30DebitAccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };



            $scope.Vat1AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Vat1Acc = {};
                    $scope.CompanyProfile2.Vat1Acc.Name = data.Name;
                    $scope.CompanyProfile2.Vat1AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Vat1Acc.Name == "") {
                        $scope.CompanyProfile2.Vat1AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Vat2AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Vat2Acc = {};
                    $scope.CompanyProfile2.Vat2Acc.Name = data.Name;
                    $scope.CompanyProfile2.Vat2AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Vat2Acc.Name == "") {
                        $scope.CompanyProfile2.Vat2AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Vat3AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Vat3Acc = {};
                    $scope.CompanyProfile2.Vat3Acc.Name = data.Name;
                    $scope.CompanyProfile2.Vat3AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile3.Vat2Acc.Name == "") {
                        $scope.CompanyProfile3.Vat2AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Vat4AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Vat4Acc = {};
                    $scope.CompanyProfile2.Vat4Acc.Name = data.Name;
                    $scope.CompanyProfile2.Vat4AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Vat4Acc.Name == "") {
                        $scope.CompanyProfile2.Vat4AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.Vat5AccAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.Vat5Acc = {};
                    $scope.CompanyProfile2.Vat5Acc.Name = data.Name;
                    $scope.CompanyProfile2.Vat5AccId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.Vat5Acc.Name == "") {
                        $scope.CompanyProfile2.Vat5AccId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };




            $scope.ProductAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.productInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };


            $scope.DefauldProductAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                //                placeholder: $scope.SearchByNameLan,
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CompanyProfile2.DefauldProduct = {};
                    $scope.CompanyProfile2.DefauldProduct.Name = data.Name;
                    $scope.CompanyProfile2.DefauldProductId = data.Id;
                    $scope.$apply();
                },
                change: function (e) {
                    if ($scope.CompanyProfile2.DefauldProduct.Name == "") {
                        $scope.CompanyProfile2.DefauldProductId = "";
                    }
                },
                minLength: 2,
                dataSource: $scope.ProductAutocompleteDataSource
            };


      }]);
